var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[(_vm.questions.length == 0)?_c('p',[_vm._v("QUESTIONS IS EMPTY")]):_vm._e(),_vm._l((_vm.questions),function(question){return _c('QuestionEditor',{key:question.designator,attrs:{"payload":{ question: question, resource_type: 'Position', resource_data: _vm.payload.position_data, resource_id: _vm.payload.position_id }}})})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }